var map = {
	"./aircon-truck.png": 1316,
	"./aircraft.png": 1317,
	"./airstarter.png": 1318,
	"./airtug.png": 1319,
	"./ambulance.png": 1320,
	"./bed.png": 1321,
	"./bicycle.png": 1322,
	"./boom-lift.png": 1323,
	"./bowser.png": 1324,
	"./boy.png": 1325,
	"./bulldozer.png": 1326,
	"./bus.png": 1327,
	"./car.png": 1328,
	"./catering-hi-lift.png": 1329,
	"./cement-mixer.png": 1330,
	"./crane.png": 1331,
	"./defueller.png": 1332,
	"./dispenser.png": 1333,
	"./excavator.png": 1334,
	"./female.png": 1335,
	"./fire-tender.png": 1336,
	"./forklift.png": 1337,
	"./galley-cart.png": 1338,
	"./garbage-wagon.png": 1339,
	"./girl.png": 1340,
	"./helmet.png": 1341,
	"./infant.png": 1342,
	"./invalid-passenger-lift.png": 1343,
	"./joint-pallet-container-loader.png": 1344,
	"./lavatory-truck.png": 1345,
	"./lorry.png": 1346,
	"./main-deck-loader.png": 1347,
	"./maintenance-platform.png": 1348,
	"./male.png": 1349,
	"./mechanical-sweeper.png": 1350,
	"./mini-bus.png": 1351,
	"./mobile-gpu.png": 1352,
	"./motorcycle.png": 1353,
	"./others.png": 1354,
	"./passenger-step.png": 1355,
	"./pmd.png": 1356,
	"./police-car.png": 1357,
	"./prime-mover.png": 1358,
	"./recovery-truck.png": 1359,
	"./scissor-lift.png": 1360,
	"./scooter.png": 1361,
	"./scrubber.png": 1362,
	"./seatbelt.png": 1363,
	"./ship.png": 1364,
	"./skyloader.png": 1365,
	"./storage-bin.png": 1366,
	"./tanker.png": 1367,
	"./tm-compressor.png": 1368,
	"./tm-gpu.png": 1369,
	"./towed-skyloader.png": 1370,
	"./tractor.png": 1371,
	"./trailer.png": 1372,
	"./tram.png": 1373,
	"./transporter.png": 1374,
	"./van.png": 1375,
	"./water-truck.png": 1376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1315;